import React from "react";

const LOGOS = [
  "65+ YEARS", "LICENSED & INSURED", "FAMILY OWNED", "BROWARD · MIAMI-DADE · PALM BEACH",
  "PET & FAMILY SAFE", "SATISFACTION GUARANTEED", "SINCE 1959",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-strip"
      className="bg-white text-neutral-900 overflow-hidden border-y border-neutral-200"
    >
      <div className="flex marquee-track py-4 sm:py-5 whitespace-nowrap">
        {[...LOGOS, ...LOGOS].map((l, i) => (
          <div key={i} className="flex items-center gap-3 sm:gap-5 px-4 sm:px-7">
            <i className="fa-solid fa-bug text-[color:var(--dbe-red)]" />
            <span className="font-bebas text-lg sm:text-2xl tracking-[0.18em] text-neutral-800">{l}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
